// // Angular
// import { Injectable } from '@angular/core';
// import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
// // RxJS
// import { Observable } from 'rxjs';
// import { tap } from 'rxjs/operators';
// import { debug } from 'util';

// /**
//  * More information there => https://medium.com/@MetonymyQT/angular-http-interceptors-what-are-they-and-how-to-use-them-52e060321088
//  */
// @Injectable()
// export class InterceptService implements HttpInterceptor {
// 	// intercept request and add token
// 	intercept(
// 		request: HttpRequest<any>,
// 		next: HttpHandler
// 	): Observable<HttpEvent<any>> {
// 		// tslint:disable-next-line:no- 
// 		// modify request
// 		// request = request.clone({
// 		// 	setHeaders: {
// 		// 		Authorization: `Bearer ${localStorage.getItem('accessToken')}`
// 		// 	}
// 		// });
// 		// console.log('----request----');
// 		// console.log(request);
// 		// console.log('--- end of request---');

// 		return next.handle(request).pipe(
// 			tap(
// 				event => {
// 					 if (event instanceof HttpResponse) {
// 						// console.log('all looks good');
// 						// http response status code
// 						// console.log(event.status);
// 					}
// 				},
// 				error => {
// 					// http response status code
// 					// console.log('----response----');
// 					// console.error('status code:');
// 					// tslint:disable-next-line:no- 
// 					console.error(error.status);
// 					console.error(error.message);
// 					// console.log('--- end of response---');
// 				}
// 			)
// 		);
// 	}
// }

import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Adm000Service } from '../../_service/adm000.service';
import { environment } from '../../../../../environments/environment';

@Injectable()
export class InterceptService implements HttpInterceptor {
    constructor(private authenticationService: Adm000Service) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with jwt token if available
        let currentUser = this.authenticationService.currentUserValue;
        // domain/subdomain of the browser, e.g. tenant.example.com
        const domain = window.location.hostname;
        const headers: { [name: string]: string } = {};

        if (currentUser && currentUser.token) {
            headers.Authorization = `Bearer ${currentUser.token}`;
        }
        // only send tenant domain header when multi-tenancy is enabled
        if (environment.MultiTenant) {
            headers['X-Domain'] = domain;
        }

        request = request.clone({ setHeaders: headers });

        return next.handle(request);
    }
}
